import {
  FETCH_LINKS_DATA_REQUEST,
  FETCH_LINKS_DATA_SUCCESS,
  FETCH_LINKS_DATA_FAILURE,
} from 'actionTypes';
import createReducer from './createReducer';

export const initialState = {
  entities: {},
  idsMap: {},
  isFetching: false,
  isRequestFailed: false,
};

const convertorLinks = createReducer(initialState, {
  [FETCH_LINKS_DATA_REQUEST]: state => ({
    ...state,
    isFetching: true,
    isRequestFailed: false,
  }),

  [FETCH_LINKS_DATA_SUCCESS]: (state, action) => {
    const { entities, ids } = action.payload;

    return {
      ...state,
      entities: {
        ...state.entities,
        ...entities.convertorLinks,
      },
      idsMap: {
        ...state.idsMap,
        [action.payload.url]: ids,
      },
      isFetching: false,
    };
  },

  [FETCH_LINKS_DATA_FAILURE]: state => ({
    ...state,
    isFetching: false,
    isRequestFailed: true,
  }),
});

export default convertorLinks;
